import React from 'react';
import { FormattedMessage } from 'react-intl';

import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { LogService } from '../../../services/log-service';
import { BillingPlanIds } from '../../../enums/billing-plan-ids';
import { getNonWalletAccessDisplayPrice } from '../../../hooks/non-wallet-access-hooks';
import FormattedCurrency from '../../formatted-currency';
import { useGetSimplifiedPlanExperimentName } from '../../../pages/settings/payment-and-subscription/components/plan-name-helper';

import { messages } from './messages';
import style from './style.module.less';

export const EnableNonWalletAccessModalBody = ({
  currentBillingPlan,
  nonWalletAccessPlan,
  nonWalletAccessPlanPrice,
  currentPlanPrice,
  subscribedButHasRemainingTrial,
  billingPlanIdFromRedux,
  hasAccessToAddNonWalletAccess,
}) => {
  const simplifiedPlanName = useGetSimplifiedPlanExperimentName(currentBillingPlan);
  if (nonWalletAccessPlan) {
    // This can only be true if a seller:
    // - has permissions to call the subscriptionInfo endpoint
    // - and is on a plan that has a sister plan with non-wallet access
    // (trials return false for this check)
    return (
      <>
        <FormattedMessage
          {...messages.modalBody}
          values={{
            addOnPrice: (
              <FormattedCurrency
                currencyCode={nonWalletAccessPlanPrice.code || 'USD'}
                value={getNonWalletAccessDisplayPrice(currentBillingPlan, nonWalletAccessPlan)}
              />
            ),
            planName: simplifiedPlanName,
          }}
        />
        <p className={style['new-monthly-subscription']}>
          <FormattedMessage {...messages.newMonthlySubscriptionText} />
        </p>
        <div className={style['price-container']}>
          <div className={style['old-price']}>
            <FormattedCurrency currencyCode={currentPlanPrice.code || 'USD'} value={currentPlanPrice.value || 0} />
          </div>
          <div className={style['new-price']}>
            <FormattedCurrency currencyCode={nonWalletAccessPlanPrice.code || 'USD'} value={nonWalletAccessPlanPrice.value || 1245} />
          </div>
        </div>
        {subscribedButHasRemainingTrial ? (
          <FormattedMessage {...messages.billingMessageButHasRemainingTrial} />
        ) : (
          <FormattedMessage {...messages.billingMessage} />
        )}
      </>
    );
  }
  if (billingPlanIdFromRedux === BillingPlanIds.Trial) {
    return (
      <>
        <FormattedMessage {...messages.modalBodyTrial} />
        <div className={style['body-message']}>
          <FormattedMessage {...messages.modalBodyTrial2} />
        </div>
      </>
    );
  }
  if (!hasAccessToAddNonWalletAccess) {
    return (
      <InlineMessage className={style['error-banner']} type={INLINE_MESSAGE_TYPES.error}>
        <FormattedMessage {...messages.noPermission} />
      </InlineMessage>
    );
  }
  LogService.logError(
    new Error(
      'EnableNonWalletAccessModalBody: Unexpected state where nonWalletAccessPlan is undefined and hasAccessToAddNonWalletAccess is true',
    ),
  );
  return null;
};
